/* eslint-disable import/no-unresolved */
/* eslint-disable import/prefer-default-export */

import API_URLS from "src/config/API_URLS";
import axiosInstance from "src/utils/Axios/axiosInstance";
import StorageService from "src/utils/Storage/storageService";

const sendReviewLink = async (leadId: string) => {
  try {
    const response: any = await axiosInstance.post(`${API_URLS.sendReviewLink}`, { leadId });
    return response;
  } catch (response: any) {
    throw new Error(response?.data?.error?.message);
  }
};

const sendOtpLink = async (uid: string) => {
  try {
    const response: any = await axiosInstance.post(`${API_URLS.sendOtp}`, { uid });
    return response;
  } catch (response: any) {
    throw new Error(response?.data?.error?.message);
  }
};

const verifyOtp = async ({ id, otp }: any) => {
  try {
    const reqBody = {
      id,
      otp
    };
    const response: any = await axiosInstance.post(`${API_URLS.verifyOtp}`, reqBody, {
      headers: {
        token: StorageService.getFromLocalStorage("verificationToken")
      }
    });
    return response;
  } catch (response: any) {
    throw new Error(response?.data?.error?.message);
  }
};

const resendOtp = async (id: string) => {
  try {
    const response: any = await axiosInstance.post(
      API_URLS.resendOTP,
      { id },
      {
        headers: {
          token: StorageService.getFromLocalStorage("verificationToken")
        }
      }
    );
    return response;
  } catch (response: any) {
    throw new Error(response?.data?.error?.message);
  }
};

const generateMef = async ({ leadId }: any) => {
  try {
    const reqBody = {
      leadId
    };
    const response: any = await axiosInstance.post(`${API_URLS.generateMef}`, reqBody);
    return response;
  } catch (response: any) {
    throw new Error(response?.data?.error?.message);
  }
};

const verifyPaymentLink = async (id: string) => {
  try {
    const response: any = await axiosInstance.post(`${API_URLS.verifyPaymentLink}`, { id });
    return response;
  } catch (response: any) {
    throw new Error(response?.data?.error?.message);
  }
};

export { sendReviewLink, sendOtpLink, verifyOtp, resendOtp, generateMef, verifyPaymentLink };
